import {
  CloudPlanItems,
  CloudTeamQuota,
  CmsPlanItems,
  CmsTeamQuota,
  PlanItem,
  PlanItems,
  ProductName,
  Quota,
  QuotaType,
  TeamQuota,
} from "../interfaces"

// auth-api が返す product_name は snake_case（`custom_domain` / `build_time`）で、
// TS 側の型は camelCase（`customDomain` / `buildTime`）。この差を
// `teamQuota[productName as keyof TeamQuota]` のようなキャストで握りつぶすと、
// 実行時に undefined になっても typecheck が通ってしまい、CLOUD のプラン画面から
// 単体追加分「(+N)」が全行消えていた（#410）。
//
// 対応表はこのファイル 1 箇所だけに置く。`Record<>` にしているので、
// ProductName に項目が増えたらここがコンパイルエラーになる。

type QuotaKey = keyof CmsTeamQuota | keyof CloudTeamQuota
type PlanItemKey = keyof CmsPlanItems | keyof CloudPlanItems

// TeamQuota の行を持つ product_name（= QuotaType）だけの対応表。
// `site` も含む（2-15 / #399）。auth-api #1181 が CLOUD の TeamQuota に site の行を
// 書くので、上限と使用量はここから読む。**単体購入できるかどうかはこの表では
// 決まらない**: 案C v4 の site は全プラン `price: 0` で、買えるかどうかの正本は
// helpers/buyableProducts.ts の BUYABLE_PRODUCTS（cloud は空）。
export const QUOTA_KEY: Record<QuotaType, QuotaKey> = {
  membership: "membership",
  bandwidth: "bandwidth",
  form: "form",
  site: "site",
  custom_domain: "customDomain",
  build_time: "buildTime",
}

// `subscription` はプラン本体の価格で、PlanItems の行ではない。
export type PlanItemProductName = Exclude<ProductName, "subscription">

export const PLAN_ITEM_KEY: Record<PlanItemProductName, PlanItemKey> = {
  membership: "membership",
  bandwidth: "bandwidth",
  form: "form",
  site: "site",
  custom_domain: "customDomain",
  build_time: "buildTime",
}

// TeamQuota は CMS / CLOUD の union。そのサービスが持たない項目は undefined を
// 返す（CMS の build_time など）。呼び出し側で必ず undefined を扱うこと。
export const quotaFor = (
  teamQuota: TeamQuota,
  productName: QuotaType,
): Quota | undefined =>
  (teamQuota as Partial<CmsTeamQuota & CloudTeamQuota>)[QUOTA_KEY[productName]]

// PlanItems も同じく union。`subscription` と、そのサービスに無い項目は undefined。
export const planItemFor = (
  items: PlanItems,
  productName: ProductName,
): PlanItem | undefined => {
  if (productName === "subscription") return undefined

  return (items as Partial<CmsPlanItems & CloudPlanItems>)[
    PLAN_ITEM_KEY[productName]
  ]
}
